import { createSelector, createFeatureSelector } from "@ngrx/store";
import { AppErrorState } from "./error.state";

export const appErrorStateSelector =
	createFeatureSelector<AppErrorState>("error");

export const appErrorSelector = createSelector(
	appErrorStateSelector,
	(state) => state
);
